import TopicsCarousel from './TopicsCarousel'

export default TopicsCarousel
